import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
import ComplimentryService from "../../../services/OrderingServices/ComplimentryService";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const ComplimentryGroupItem = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalData: 0,
  });
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const [dateRange, setDateRange] = useState([null, null]);
  const [filterText, setFilterText] = useState("");
  const formatDate = (date) => {
    if (!date) return null;
    return date.toLocaleDateString("en-CA"); // en-CA gives YYYY-MM-DD
  };

  const fetchData = async (page = 1, pageSize = pagination?.pageSize) => {
    setLoading(true);
    try {
      const response = await ComplimentryService.getGrpItem({
        page,
        pageSize,
        startDate: formatDate(dateRange[0]),
        endDate: formatDate(dateRange[1]),
      });

      if (response) {
        setAllData(response);
        setPagination({
          currentPage: response.currentPage,
          pageSize: response.pageSize,
          totalPages: response.totalPages,
          totalData: response.totalData,
        });
      } else {
        setAllData([]);
        setPagination((prev) => ({ ...prev, totalData: 0 }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // fetch when filters change
  useEffect(() => {
    fetchData(1);
  }, [dateRange, filterText]);

  // columns
  const flattenedData = allData.flatMap((order) =>
    order.items.flatMap((item) =>
      item.logs.map((log) => ({
        orderId: order.orderId,
        itemId: item.itemId,
        itemName: item.itemName,
        totalQuantity: item.totalQuantity,
        logId: log.id,
        logQuantity: log.quantity,
        reason: log.reason || "-",
        createdAt: new Date(log.createdAt).toLocaleString(),
        givenBy: log.givenBy,
      }))
    )
  );

  // 🔹 Define DataTable columns
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "70px",
    },
    {
      name: "Order ID",
      selector: (row) => row.orderId,
      sortable: true,
    },
    // {
    //   name: "Item ID",
    //   selector: (row) => row.itemId,
    //   sortable: true,
    // },
    {
      name: "Item Name",
      selector: (row) => (
        <Link to={`/item/detail/${row?.itemId}`}>{row.itemName}</Link>
      ),
      sortable: true,
    },
    {
      name: "Total Qty",
      selector: (row) => row.totalQuantity,
      sortable: true,
      right: true,
      width: "9vw",
    },
    {
      name: "Log ID",
      selector: (row) => row.logId,
      sortable: true,
      width: "8vw",
    },
    {
      name: "Log Qty",
      selector: (row) => row.logQuantity,
      sortable: true,
      right: true,
      width: "8vw",
    },

    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
    },
    // {
    //   name: "Given By",
    //   selector: (row) => row.givenBy,
    // },
  ];

  return (
    <>
      <Card>
        <CardBody>
          {/* Filters */}
          <Row className="mb-3">
            <Col md={4}>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
            </Col>
            <Col md={4}>
              <Input
                type="text"
                placeholder="Search..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
          </Row>

          {/* Table */}
          <CustomDataTable
            responsive
            striped
            pagination
            paginationServer
            paginationTotalRows={pagination.totalData}
            paginationDefaultPage={pagination.currentPage}
            onChangePage={(page) => fetchData(page)}
            onChangeRowsPerPage={(newPageSize) => fetchData(1, newPageSize)}
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={{
              headCells: {
                style: {
                  fontSize: "0.93rem",
                  fontWeight: 610,
                },
              },
              rows: {
                style: {
                  fontSize: "0.9rem",
                },
              },
            }}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={flattenedData}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ComplimentryGroupItem;
